<template>
  <div>
    <button @click="getCalificaciones()">Generar PDF sin</button>
    <div style="display: none" id="generalBoletasSin">
        <div v-for="(alumno, a) in alumnos" :key="a">
            <div class="alumno" style="width: 1240px; height: 1754px;">
                <div class="content">
                    <div style="height: 150px; background: #D9D9D9; margin-bottom: 5px; display:flex; align-items: center; justify-content: center;">
                        <p class="text-center mb-0">ENCABEZADO</p>
                    </div>
                    <div style="border: 1px solid #D9D9D9; padding: 5px 9px; margin-bottom: 5px;">
                        <vs-row>
                            <vs-col w="5">
                                <p class="fontSix lineTogether"><strong>ALUMNO: </strong> <span class="text-uppercase">{{alumno.nombre}}</span></p>
                            </vs-col>
                            <vs-col w="3">
                                <p class="fontSix lineTogether" style="padding: 0 9px;"><strong>MATRÍCULA: </strong> <span class="text-uppercase">{{alumno.matricula}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontSix lineTogether" style="padding-right: 18px;"><strong>EMAIL: </strong> <span class="text-uppercase">{{alumno.correo_institucional}}</span></p>
                            </vs-col>
                            <vs-col w="5">
                                <p class="fontSix lineTogether"><strong>SALÓN: </strong> <span class="text-uppercase">{{alumno.grupo_administrativo}}</span></p>
                            </vs-col>
                            <vs-col w="3">
                                <p class="fontSix lineTogether" style="padding: 0 9px;"><strong>NO. LISTA: </strong> <span class="text-uppercase">{{alumno.no_lista}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontSix lineTogether" style="padding-right: 18px;"><strong>CICLO: </strong> <span>Ciclo Escolar 2023 - 2024</span></p>
                            </vs-col>
                            <vs-col w="5">
                                <p class="fontSix lineTogether"><strong>PROGRAMA: </strong> <span class="text-uppercase">PRIMARIA MATUTINA</span></p>
                            </vs-col>
                            <vs-col w="3">
                                <p class="fontSix lineTogether" style="padding: 0 9px;"><strong>GRADO: </strong> <span class="text-uppercase">{{alumno.grado}}</span></p>
                            </vs-col>
                        </vs-row>
                    </div>
                    <div class="d-flex">
                        <div style="width: 25%">
                        </div>
                        <div class="d-flex" style="width: 75%">
                            <template v-for="(cabecera, c) in alumno.header_periodos">
                                <div v-if="tipo_formato == 'admin' ? true : verInfo[c] && verInfo[c].status == true" :key="c" class="fontSix px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                    <p style="hyphens: auto;">{{cabecera.periodo}}</p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="backgroundCampos mt-1" v-for="(mat, m) in alumno.materias_promediables.materias" :key="m">
                        <div class="d-flex align-items-center">
                            <div style="width: 25%; padding-left: 3px;">
                                <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span> ({{mat.clave}})</p>
                                <p class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                <p v-if="mat.no_asistencia" class="fontSix lineTogether" style="text-transform: capitalize;">No. de asistencia: <span class="font-weight-bold text-capitalize">{{mat.no_asistencia}}/{{mat.no_asistencia_total}}</span></p>
                            </div>
                            <div class="d-flex" style="width: 75%" >
                                <template v-for="(cal, ca) in mat.periodos">
                                    <div v-if="tipo_formato == 'admin' ? true : cal.detalle_componente_id == verInfo[ca].detalle" :key="ca" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                        <p v-if="cal.calificacion !== '' && cal.calificacion !== null">{{cal.calificacion == 0 ? '-' : cal.calificacion}}</p>
                                        <p v-else>-</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div :class="alumno.materias_promediables.materias != (m + 1) ? 'lineSeparador' : ''"></div>
                    </div>
                    <div class="d-flex align-items-center" style="background:#1B3966; padding: 6px 0; color: white;">
                        <div style="width: 25%">
                            <p class="text-right font-weight-bold fontNine" style="line-height: 1;"><i>Promedio</i></p>
                        </div>
                        <div class="d-flex" style="width: 75%" >
                            <div v-for="(per, p) in alumno.header_periodos" class="fontSix px-1 cabeceraTable" :key="p" :class="'widthCabecera' + numCabecera">
                                <p class="text-uppercase font-weight-bold fontNine" style="line-height: 1;">{{getPromediosById(alumno.materias_promediables.promedio_general, per)}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="backgroundCampos" v-for="(mat, mn) in alumno.materias_no_promediables" :key="mn + 'a'">
                        <div class="d-flex align-items-center">
                            <div style="width: 25%; padding-left: 3px;">
                                <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span><span v-if="mat.clave">({{mat.clave}})</span> </p>
                                <p v-if="mat.docente" class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                <p v-if="mat.no_asistencia" class="fontSix lineTogether" style="text-transform: capitalize;">No. de asistencia: <span class="font-weight-bold text-capitalize">{{mat.no_asistencia}}/{{mat.no_asistencia_total}}</span></p>
                            </div>
                            <div class="d-flex" style="width: 75%" >
                                <template v-for="(cal, ca) in mat.periodos">
                                    <div v-if="tipo_formato == 'admin' ? true : cal.detalle_componente_id == verInfo[ca].detalle" :key="ca" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                        <p v-if="cal.calificacion !== '' && cal.calificacion !== null">{{cal.calificacion == 0 ? '-' : cal.calificacion}}</p>
                                        <p v-else>-</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="lineSeparadorCampoFormativo"></div>
                    </div>
                </div>
                <div class="bottom-div" style="height: 150px; background: #D9D9D9; margin-bottom: 5px;">
                    <p class="text-center mb-0">Pie de página</p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
export default {
    props: [
        'filtros',
        'selected',
        'nivel'
    ],
    data:() => ({
        tipo: 1,
        alumnos:[],
        numCabecera: '',
        tipo_formato: '',
        verInfo: []
    }),
  methods: {
    getNumTotalCabecera(){
        const cabecera = this.alumnos[0].header_periodos
        const rol = 'administrador'
        const vm = this
        if(rol == 'administrador'){
            vm.numCabecera = cabecera.length
        }
        console.log(vm.numCabecera)
    },
    getCalificacionById(periodos, cabecera){
        let calif = ''
        periodos.forEach(p => {
            if(p.detalle_componente_id == cabecera.detalle_componente_id){
                calif = p.calificacion
                return false
            }
        })
        return calif
    },
    getPromediosById(periodos, promedio){
        //Colocar el promedio en el periodo correspondiente
        let calif = ''
        periodos.forEach(p => {
            if(p.detalle_componente_id == promedio.detalle_componente_id){
                calif = p.calificacion
                return false
            }
        })
        return calif
    },
    getPeriodosShow(info){
        const arreglo = []
        const infor = this.alumnos[0].header_periodos
        infor.forEach(element => {
            let array = {}
            if(element.status_show_alumno == true){
                array = {
                    detalle: element.detalle_componente_id,
                    status: true
                }
            }else{
                array = {
                    nombre: false,
                    status: false
                }
            }
            arreglo.push(array)
        })
        this.verInfo = arreglo
    },
    generarPDF() {
        const loading = this.$vs.loading({
            text: 'Descargando PDF, esto puede demorar un poco.'
        })
        var intro = document.getElementById('generalBoletasSin')
        intro.style.display = 'block'
        // Seleccionar el contenido que deseas convertir a PDF
        const pages = document.querySelectorAll('.alumno')
            const pdf = new jsPDF({
            orientation: 'portrait', // o 'landscape'
            unit: 'mm',
            format: 'letter',
            compress: true,
            fontSize: 12,
            lineHeight: 1.2,
            setMargins: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        });
        
        console.log("aqui entri1", pages)
        pages.forEach((page, index) => {
        console.log("aqui entri 2")
            // Utilizar html2canvas para capturar el contenido como una imagen
            html2canvas(page, {
                scale: 1, // Ajusta la escala para mejorar la calidad
                quality: 0.9, // Ajusta la calidad de la imagen
            }).then(canvas => {

        console.log("aqui entri 3")
                // Convertir la imagen en base64 y agregarla al PDF
                const imageData = canvas.toDataURL('image/png');
                pdf.addImage(imageData, 'PNG', 3, 3, 210, 273);

                // Agregar una nueva página si no es la última
                if (index < pages.length - 1) {
                    pdf.addPage();
                } else {
                    // Guardar el PDF cuando se procesan todas las páginas
                    pdf.save('Boleta');
                    intro.style.display = 'none';
                    this.$emit('loadingBoton');
                    loading.close()
                }
            })
        })
    
        intro.style.display = 'none';
    },
    
    async getCalificaciones (tipo) {
        this.tipo_formato = tipo
        this.alumnos = []
        const loading = this.$vs.loading({
            text: 'Por favor, espere. Esto puede tardar un poco.',
        })
            try {
                // const params = {
                    // ciclo_escolar_id:  this.filtros.cicloEscolar,
                    // institucion_id: this.filtros.institucion,
                    // programa_id: this.filtros.programa
                // }
                // let datos = [663]
                // for(var x = 0;x < this.selected.length; x++){
                //     datos.push(this.selected[x].persona_id)
                // }
                
                // params.persona_alumno_id = datos
                // params.accion = 'descarga'
                // const { data: response } = await reportes.getDescargarBoletas(params)
                this.alumnos = [{
    "matricula": "MRMA610",
    "nombre": "AMARO AREVALO MARIA FERNANDA",
    "persona_id": 610,
    "registro_academico_id": 123227,
    "institucion_id": 4,
    "ciclo_escolar_id": 28,
    "programa_id": 4,
    "correo_institucional": "MRMA610@potosino.maristas.edu.mx",
    "grupo_administrativo": "11",
    "no_lista": 1,
    "grado": "Grado (A\u00f1o) 1",
    "materias_promediables": {
        "materias": [
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5160,
                "docente": "ARAIZA RODRIGUEZ PAOLA",
                "materia": "LENGUA MATERNA I",
                "clave": "1",
                "promedia": "si",
                "codigo_sesion_id": 6948,
                "campo_formativo_id": 1,
                "orden_materia": 1,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1891982,
                        "calificacion": 8,
                        "faltas": 1,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 2,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1926986,
                        "calificacion": 8,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1926986,
                        "calificacion": 8,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5487,
                "docente": "BARRIENTOS JIMENEZ MARIA DE GUADALUPE",
                "materia": "LENGUA EXTRANJERA I",
                "clave": "3",
                "promedia": "si",
                "codigo_sesion_id": 6950,
                "campo_formativo_id": 1,
                "orden_materia": 2,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1889540,
                        "calificacion": 8,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1922827,
                        "calificacion": 9,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1922827,
                        "calificacion": 9,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5247,
                "docente": "SOTO NIETO SALVADOR",
                "materia": "ARTES I",
                "clave": "10",
                "promedia": "si",
                "codigo_sesion_id": 6957,
                "campo_formativo_id": 1,
                "orden_materia": 3,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1861135,
                        "calificacion": 10,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1916983,
                        "calificacion": 10,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1916983,
                        "calificacion": 10,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5215,
                "docente": "MORAN RODRIGUEZ JORGE LUIS",
                "materia": "MATEM\u00c1TICAS I",
                "clave": "2",
                "promedia": "si",
                "codigo_sesion_id": 6949,
                "campo_formativo_id": 2,
                "orden_materia": 4,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1890636,
                        "calificacion": 7,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1933828,
                        "calificacion": 6,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1933828,
                        "calificacion": 7,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 65255,
                "docente": "RAMIREZ LOPEZ BLANCA MICHELLE",
                "materia": "CIENCIAS I",
                "clave": "4",
                "promedia": "si",
                "codigo_sesion_id": 6951,
                "campo_formativo_id": 2,
                "orden_materia": 5,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1885617,
                        "calificacion": 9,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1938030,
                        "calificacion": 7,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 2,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1938030,
                        "calificacion": 8,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5222,
                "docente": "ORTIZ HERNANDEZ ROSARIO AIDE",
                "materia": "GEOGRAF\u00cdA",
                "clave": "6",
                "promedia": "si",
                "codigo_sesion_id": 6953,
                "campo_formativo_id": 3,
                "orden_materia": 6,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1891744,
                        "calificacion": 7,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1937633,
                        "calificacion": 10,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1937633,
                        "calificacion": 9,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 65253,
                "docente": "HERRERA GONZ\u00c1LEZ ROSA MARGARITA",
                "materia": "HISTORIA I",
                "clave": "5",
                "promedia": "si",
                "codigo_sesion_id": 6952,
                "campo_formativo_id": 3,
                "orden_materia": 7,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1883175,
                        "calificacion": 8,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1936838,
                        "calificacion": 9,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1936838,
                        "calificacion": 9,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5222,
                "docente": "ORTIZ HERNANDEZ ROSARIO AIDE",
                "materia": "FORMACI\u00d3N C\u00cdVICA Y \u00c9TICA I",
                "clave": "7",
                "promedia": "si",
                "codigo_sesion_id": 6954,
                "campo_formativo_id": 3,
                "orden_materia": 8,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1891914,
                        "calificacion": 8,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1937848,
                        "calificacion": 8,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1937848,
                        "calificacion": 8,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5182,
                "docente": "GALLEGOS TORANZO JOSE RAFAEL",
                "materia": "TECNOLOG\u00cdA I",
                "clave": "8",
                "promedia": "si",
                "codigo_sesion_id": 6955,
                "campo_formativo_id": 4,
                "orden_materia": 9,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1883677,
                        "calificacion": 10,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1915268,
                        "calificacion": 10,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1915268,
                        "calificacion": 10,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            },
            {
                "registro_academico": 123227,
                "componente_academico_id": 160,
                "docente_id": 5214,
                "docente": "MENDEZ EVANGELISTA ERICK PAUL",
                "materia": "EDUCACI\u00d3N F\u00cdSICA I",
                "clave": "9",
                "promedia": "si",
                "codigo_sesion_id": 6956,
                "campo_formativo_id": 4,
                "orden_materia": 10,
                "periodos": [
                    {
                        "configuracion_evaluacion_id": 695,
                        "detalle_componente_id": 952,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 1,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 1",
                        "calificacion_id": 1887531,
                        "calificacion": 10,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 953,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 2,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 2",
                        "calificacion_id": 1912976,
                        "calificacion": 10,
                        "faltas": 0,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": 0,
                        "observaciones": false,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 718,
                        "detalle_componente_id": 958,
                        "detalle_componente_tipo": "calculado",
                        "detalle_componente_orden": 3,
                        "detalle_componente_promedio_acreditable": "6",
                        "detalle_componente_calificacion_minima_reprobatoria": "5",
                        "periodo": "Trimestre 1",
                        "calificacion_id": 1912976,
                        "calificacion": 10,
                        "faltas": "",
                        "retardos": "",
                        "conducta": "",
                        "tareas_no_hechas": "",
                        "observaciones": "",
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 959,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 4,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 960,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 5,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 4",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 961,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 6,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 2",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 962,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 7,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 5",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 963,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 8,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Periodo 6",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 0,
                        "detalle_componente_id": 964,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 9,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Trimestre 3",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": 0,
                        "retardos": 0,
                        "conducta": 0,
                        "tareas_no_hechas": 0,
                        "observaciones": 0,
                        "status_captura_docente": true
                    },
                    {
                        "configuracion_evaluacion_id": 741,
                        "detalle_componente_id": 965,
                        "detalle_componente_tipo": "entrada",
                        "detalle_componente_orden": 10,
                        "detalle_componente_promedio_acreditable": null,
                        "detalle_componente_calificacion_minima_reprobatoria": null,
                        "periodo": "Promedio Final",
                        "calificacion_id": 0,
                        "calificacion": 0,
                        "faltas": false,
                        "retardos": false,
                        "conducta": false,
                        "tareas_no_hechas": false,
                        "observaciones": false,
                        "status_captura_docente": true
                    }
                ],
                "headers_global": [
                    {
                        "ponderacion": 1,
                        "periodo": "Periodo 1"
                    },
                    {
                        "ponderacion": 2,
                        "periodo": "Periodo 2"
                    },
                    {
                        "ponderacion": 3,
                        "periodo": "Trimestre 1"
                    },
                    {
                        "ponderacion": 4,
                        "periodo": "Periodo 3"
                    },
                    {
                        "ponderacion": 5,
                        "periodo": "Periodo 4"
                    },
                    {
                        "ponderacion": 6,
                        "periodo": "Trimestre 2"
                    },
                    {
                        "ponderacion": 7,
                        "periodo": "Periodo 5"
                    },
                    {
                        "ponderacion": 8,
                        "periodo": "Periodo 6"
                    },
                    {
                        "ponderacion": 9,
                        "periodo": "Trimestre 3"
                    },
                    {
                        "ponderacion": 10,
                        "periodo": "Promedio Final"
                    }
                ],
                "headers_codigo_sesion": {
                    "header_faltas": "show",
                    "header_retardos": "not_show",
                    "header_conducta": "not_show",
                    "header_tareas_no_hechas": "show",
                    "header_observaciones": "not_show"
                },
                "escala_calificacion": {
                    "id": 1,
                    "nombre": "Escala (5-10)",
                    "tipo_escala": "numerica",
                    "valor_minimo": 5,
                    "valor_maximo": 10,
                    "valor_acreditable": 6,
                    "tipo_numerico": "entero",
                    "decimales": null,
                    "valores_alfanumericos": [
                        ""
                    ],
                    "valores_alfanumericos_acreditables": [
                        ""
                    ],
                    "descripcion": "Escala de 5 - 10, sin decimales",
                    "created_at": "2020-09-22T18:50:02.000000Z",
                    "updated_at": "2022-11-16T14:44:32.000000Z"
                }
            }
        ],
        "promedio_general": [
            {
                "detalle_componente_id": 952,
                "periodo": "Periodo 1",
                "calificacion_id": 1891982,
                "calificacion": 8.5
            },
            {
                "detalle_componente_id": 953,
                "periodo": "Periodo 2",
                "calificacion_id": 1926986,
                "calificacion": 8.7
            },
            {
                "detalle_componente_id": 958,
                "periodo": "Trimestre 1",
                "calificacion_id": 1926986,
                "calificacion": 8.8
            }
        ]
    },
    "materias_no_promediables": [
        {
            "registro_academico": 123227,
            "componente_academico_id": 160,
            "docente_id": 74053,
            "docente": "MENDOZA TORRES RA\u00daL DARIO",
            "materia": "ED. SOCIOEMOCIONAL I",
            "clave": "12",
            "promedia": "no",
            "codigo_sesion_id": 6959,
            "campo_formativo_id": 4,
            "orden_materia": 11,
            "periodos": [
                {
                    "configuracion_evaluacion_id": 695,
                    "detalle_componente_id": 952,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 1,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 1",
                    "calificacion_id": 1894395,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 953,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 2,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 2",
                    "calificacion_id": 1931003,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 958,
                    "detalle_componente_tipo": "calculado",
                    "detalle_componente_orden": 3,
                    "detalle_componente_promedio_acreditable": "6",
                    "detalle_componente_calificacion_minima_reprobatoria": "5",
                    "periodo": "Trimestre 1",
                    "calificacion_id": 1931003,
                    "calificacion": 10,
                    "faltas": "",
                    "retardos": "",
                    "conducta": "",
                    "tareas_no_hechas": "",
                    "observaciones": "",
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 959,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 4,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 960,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 5,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 4",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 961,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 6,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 2",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 962,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 7,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 5",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 963,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 8,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 6",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 964,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 9,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 741,
                    "detalle_componente_id": 965,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 10,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Promedio Final",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": false,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": false,
                    "observaciones": false,
                    "status_captura_docente": true
                }
            ],
            "headers_global": [
                {
                    "ponderacion": 1,
                    "periodo": "Periodo 1"
                },
                {
                    "ponderacion": 2,
                    "periodo": "Periodo 2"
                },
                {
                    "ponderacion": 3,
                    "periodo": "Trimestre 1"
                },
                {
                    "ponderacion": 4,
                    "periodo": "Periodo 3"
                },
                {
                    "ponderacion": 5,
                    "periodo": "Periodo 4"
                },
                {
                    "ponderacion": 6,
                    "periodo": "Trimestre 2"
                },
                {
                    "ponderacion": 7,
                    "periodo": "Periodo 5"
                },
                {
                    "ponderacion": 8,
                    "periodo": "Periodo 6"
                },
                {
                    "ponderacion": 9,
                    "periodo": "Trimestre 3"
                },
                {
                    "ponderacion": 10,
                    "periodo": "Promedio Final"
                }
            ],
            "headers_codigo_sesion": {
                "header_faltas": "show",
                "header_retardos": "not_show",
                "header_conducta": "not_show",
                "header_tareas_no_hechas": "show",
                "header_observaciones": "not_show"
            },
            "escala_calificacion": {
                "id": 1,
                "nombre": "Escala (5-10)",
                "tipo_escala": "numerica",
                "valor_minimo": 5,
                "valor_maximo": 10,
                "valor_acreditable": 6,
                "tipo_numerico": "entero",
                "decimales": null,
                "valores_alfanumericos": [
                    ""
                ],
                "valores_alfanumericos_acreditables": [
                    ""
                ],
                "descripcion": "Escala de 5 - 10, sin decimales",
                "created_at": "2020-09-22T18:50:02.000000Z",
                "updated_at": "2022-11-16T14:44:32.000000Z"
            }
        },
        {
            "registro_academico": 123227,
            "componente_academico_id": 160,
            "docente_id": 65253,
            "docente": "HERRERA GONZ\u00c1LEZ ROSA MARGARITA",
            "materia": "INTEGRACI\u00d3N CURRICULAR I",
            "clave": "11",
            "promedia": "no",
            "codigo_sesion_id": 6958,
            "campo_formativo_id": null,
            "orden_materia": 12,
            "periodos": [
                {
                    "configuracion_evaluacion_id": 695,
                    "detalle_componente_id": 952,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 1,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 1",
                    "calificacion_id": 1884840,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 953,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 2,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 2",
                    "calificacion_id": 1937068,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 958,
                    "detalle_componente_tipo": "calculado",
                    "detalle_componente_orden": 3,
                    "detalle_componente_promedio_acreditable": "6",
                    "detalle_componente_calificacion_minima_reprobatoria": "5",
                    "periodo": "Trimestre 1",
                    "calificacion_id": 1937068,
                    "calificacion": 10,
                    "faltas": "",
                    "retardos": "",
                    "conducta": "",
                    "tareas_no_hechas": "",
                    "observaciones": "",
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 959,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 4,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 960,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 5,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 4",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 961,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 6,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 2",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 962,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 7,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 5",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 963,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 8,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 6",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 964,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 9,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 741,
                    "detalle_componente_id": 965,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 10,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Promedio Final",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": false,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": false,
                    "observaciones": false,
                    "status_captura_docente": true
                }
            ],
            "headers_global": [
                {
                    "ponderacion": 1,
                    "periodo": "Periodo 1"
                },
                {
                    "ponderacion": 2,
                    "periodo": "Periodo 2"
                },
                {
                    "ponderacion": 3,
                    "periodo": "Trimestre 1"
                },
                {
                    "ponderacion": 4,
                    "periodo": "Periodo 3"
                },
                {
                    "ponderacion": 5,
                    "periodo": "Periodo 4"
                },
                {
                    "ponderacion": 6,
                    "periodo": "Trimestre 2"
                },
                {
                    "ponderacion": 7,
                    "periodo": "Periodo 5"
                },
                {
                    "ponderacion": 8,
                    "periodo": "Periodo 6"
                },
                {
                    "ponderacion": 9,
                    "periodo": "Trimestre 3"
                },
                {
                    "ponderacion": 10,
                    "periodo": "Promedio Final"
                }
            ],
            "headers_codigo_sesion": {
                "header_faltas": "show",
                "header_retardos": "not_show",
                "header_conducta": "not_show",
                "header_tareas_no_hechas": "show",
                "header_observaciones": "not_show"
            },
            "escala_calificacion": {
                "id": 1,
                "nombre": "Escala (5-10)",
                "tipo_escala": "numerica",
                "valor_minimo": 5,
                "valor_maximo": 10,
                "valor_acreditable": 6,
                "tipo_numerico": "entero",
                "decimales": null,
                "valores_alfanumericos": [
                    ""
                ],
                "valores_alfanumericos_acreditables": [
                    ""
                ],
                "descripcion": "Escala de 5 - 10, sin decimales",
                "created_at": "2020-09-22T18:50:02.000000Z",
                "updated_at": "2022-11-16T14:44:32.000000Z"
            }
        },
        {
            "registro_academico": 123227,
            "componente_academico_id": 160,
            "docente_id": 5186,
            "docente": "GOMEZ ROBLES RAUL",
            "materia": "CLUB DE EST\u00c9TICAS I",
            "clave": "13",
            "promedia": "no",
            "codigo_sesion_id": 6960,
            "campo_formativo_id": null,
            "orden_materia": 13,
            "periodos": [
                {
                    "configuracion_evaluacion_id": 695,
                    "detalle_componente_id": 952,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 1,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 1",
                    "calificacion_id": 1871714,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 953,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 2,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 2",
                    "calificacion_id": 1911384,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 958,
                    "detalle_componente_tipo": "calculado",
                    "detalle_componente_orden": 3,
                    "detalle_componente_promedio_acreditable": "6",
                    "detalle_componente_calificacion_minima_reprobatoria": "5",
                    "periodo": "Trimestre 1",
                    "calificacion_id": 1911384,
                    "calificacion": 10,
                    "faltas": "",
                    "retardos": "",
                    "conducta": "",
                    "tareas_no_hechas": "",
                    "observaciones": "",
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 959,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 4,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 960,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 5,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 4",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 961,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 6,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 2",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 962,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 7,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 5",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 963,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 8,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 6",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 964,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 9,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 741,
                    "detalle_componente_id": 965,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 10,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Promedio Final",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": false,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": false,
                    "observaciones": false,
                    "status_captura_docente": true
                }
            ],
            "headers_global": [
                {
                    "ponderacion": 1,
                    "periodo": "Periodo 1"
                },
                {
                    "ponderacion": 2,
                    "periodo": "Periodo 2"
                },
                {
                    "ponderacion": 3,
                    "periodo": "Trimestre 1"
                },
                {
                    "ponderacion": 4,
                    "periodo": "Periodo 3"
                },
                {
                    "ponderacion": 5,
                    "periodo": "Periodo 4"
                },
                {
                    "ponderacion": 6,
                    "periodo": "Trimestre 2"
                },
                {
                    "ponderacion": 7,
                    "periodo": "Periodo 5"
                },
                {
                    "ponderacion": 8,
                    "periodo": "Periodo 6"
                },
                {
                    "ponderacion": 9,
                    "periodo": "Trimestre 3"
                },
                {
                    "ponderacion": 10,
                    "periodo": "Promedio Final"
                }
            ],
            "headers_codigo_sesion": {
                "header_faltas": "show",
                "header_retardos": "not_show",
                "header_conducta": "not_show",
                "header_tareas_no_hechas": "show",
                "header_observaciones": "not_show"
            },
            "escala_calificacion": {
                "id": 1,
                "nombre": "Escala (5-10)",
                "tipo_escala": "numerica",
                "valor_minimo": 5,
                "valor_maximo": 10,
                "valor_acreditable": 6,
                "tipo_numerico": "entero",
                "decimales": null,
                "valores_alfanumericos": [
                    ""
                ],
                "valores_alfanumericos_acreditables": [
                    ""
                ],
                "descripcion": "Escala de 5 - 10, sin decimales",
                "created_at": "2020-09-22T18:50:02.000000Z",
                "updated_at": "2022-11-16T14:44:32.000000Z"
            }
        },
        {
            "registro_academico": 123227,
            "componente_academico_id": 160,
            "docente_id": 5204,
            "docente": "MARTINEZ MENDEZ LUZ MONICA",
            "materia": "FORMACION INTEGRAL I",
            "clave": "14",
            "promedia": "no",
            "codigo_sesion_id": 6961,
            "campo_formativo_id": null,
            "orden_materia": 14,
            "periodos": [
                {
                    "configuracion_evaluacion_id": 695,
                    "detalle_componente_id": 952,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 1,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 1",
                    "calificacion_id": 1883141,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 953,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 2,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 2",
                    "calificacion_id": 1934214,
                    "calificacion": 8,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 958,
                    "detalle_componente_tipo": "calculado",
                    "detalle_componente_orden": 3,
                    "detalle_componente_promedio_acreditable": "6",
                    "detalle_componente_calificacion_minima_reprobatoria": "5",
                    "periodo": "Trimestre 1",
                    "calificacion_id": 1934214,
                    "calificacion": 9,
                    "faltas": "",
                    "retardos": "",
                    "conducta": "",
                    "tareas_no_hechas": "",
                    "observaciones": "",
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 959,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 4,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 960,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 5,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 4",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 961,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 6,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 2",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 962,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 7,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 5",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 963,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 8,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 6",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 964,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 9,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 741,
                    "detalle_componente_id": 965,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 10,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Promedio Final",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": false,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": false,
                    "observaciones": false,
                    "status_captura_docente": true
                }
            ],
            "headers_global": [
                {
                    "ponderacion": 1,
                    "periodo": "Periodo 1"
                },
                {
                    "ponderacion": 2,
                    "periodo": "Periodo 2"
                },
                {
                    "ponderacion": 3,
                    "periodo": "Trimestre 1"
                },
                {
                    "ponderacion": 4,
                    "periodo": "Periodo 3"
                },
                {
                    "ponderacion": 5,
                    "periodo": "Periodo 4"
                },
                {
                    "ponderacion": 6,
                    "periodo": "Trimestre 2"
                },
                {
                    "ponderacion": 7,
                    "periodo": "Periodo 5"
                },
                {
                    "ponderacion": 8,
                    "periodo": "Periodo 6"
                },
                {
                    "ponderacion": 9,
                    "periodo": "Trimestre 3"
                },
                {
                    "ponderacion": 10,
                    "periodo": "Promedio Final"
                }
            ],
            "headers_codigo_sesion": {
                "header_faltas": "show",
                "header_retardos": "not_show",
                "header_conducta": "not_show",
                "header_tareas_no_hechas": "show",
                "header_observaciones": "not_show"
            },
            "escala_calificacion": {
                "id": 1,
                "nombre": "Escala (5-10)",
                "tipo_escala": "numerica",
                "valor_minimo": 5,
                "valor_maximo": 10,
                "valor_acreditable": 6,
                "tipo_numerico": "entero",
                "decimales": null,
                "valores_alfanumericos": [
                    ""
                ],
                "valores_alfanumericos_acreditables": [
                    ""
                ],
                "descripcion": "Escala de 5 - 10, sin decimales",
                "created_at": "2020-09-22T18:50:02.000000Z",
                "updated_at": "2022-11-16T14:44:32.000000Z"
            }
        },
        {
            "registro_academico": 123227,
            "componente_academico_id": 160,
            "docente_id": 5204,
            "docente": "MARTINEZ MENDEZ LUZ MONICA",
            "materia": "CONDUCTA I",
            "clave": "15",
            "promedia": "no",
            "codigo_sesion_id": 6991,
            "campo_formativo_id": null,
            "orden_materia": 15,
            "periodos": [
                {
                    "configuracion_evaluacion_id": 695,
                    "detalle_componente_id": 952,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 1,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 1",
                    "calificacion_id": 1900147,
                    "calificacion": 10,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 953,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 2,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 2",
                    "calificacion_id": 1939012,
                    "calificacion": 9,
                    "faltas": 0,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": 0,
                    "observaciones": false,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 718,
                    "detalle_componente_id": 958,
                    "detalle_componente_tipo": "calculado",
                    "detalle_componente_orden": 3,
                    "detalle_componente_promedio_acreditable": "6",
                    "detalle_componente_calificacion_minima_reprobatoria": "5",
                    "periodo": "Trimestre 1",
                    "calificacion_id": 1939012,
                    "calificacion": 10,
                    "faltas": "",
                    "retardos": "",
                    "conducta": "",
                    "tareas_no_hechas": "",
                    "observaciones": "",
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 959,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 4,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 960,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 5,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 4",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 961,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 6,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 2",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 962,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 7,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 5",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 963,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 8,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Periodo 6",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 0,
                    "detalle_componente_id": 964,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 9,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Trimestre 3",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": 0,
                    "retardos": 0,
                    "conducta": 0,
                    "tareas_no_hechas": 0,
                    "observaciones": 0,
                    "status_captura_docente": true
                },
                {
                    "configuracion_evaluacion_id": 741,
                    "detalle_componente_id": 965,
                    "detalle_componente_tipo": "entrada",
                    "detalle_componente_orden": 10,
                    "detalle_componente_promedio_acreditable": null,
                    "detalle_componente_calificacion_minima_reprobatoria": null,
                    "periodo": "Promedio Final",
                    "calificacion_id": 0,
                    "calificacion": 0,
                    "faltas": false,
                    "retardos": false,
                    "conducta": false,
                    "tareas_no_hechas": false,
                    "observaciones": false,
                    "status_captura_docente": true
                }
            ],
            "headers_global": [
                {
                    "ponderacion": 1,
                    "periodo": "Periodo 1"
                },
                {
                    "ponderacion": 2,
                    "periodo": "Periodo 2"
                },
                {
                    "ponderacion": 3,
                    "periodo": "Trimestre 1"
                },
                {
                    "ponderacion": 4,
                    "periodo": "Periodo 3"
                },
                {
                    "ponderacion": 5,
                    "periodo": "Periodo 4"
                },
                {
                    "ponderacion": 6,
                    "periodo": "Trimestre 2"
                },
                {
                    "ponderacion": 7,
                    "periodo": "Periodo 5"
                },
                {
                    "ponderacion": 8,
                    "periodo": "Periodo 6"
                },
                {
                    "ponderacion": 9,
                    "periodo": "Trimestre 3"
                },
                {
                    "ponderacion": 10,
                    "periodo": "Promedio Final"
                }
            ],
            "headers_codigo_sesion": {
                "header_faltas": "show",
                "header_retardos": "not_show",
                "header_conducta": "not_show",
                "header_tareas_no_hechas": "show",
                "header_observaciones": "not_show"
            },
            "escala_calificacion": {
                "id": 1,
                "nombre": "Escala (5-10)",
                "tipo_escala": "numerica",
                "valor_minimo": 5,
                "valor_maximo": 10,
                "valor_acreditable": 6,
                "tipo_numerico": "entero",
                "decimales": null,
                "valores_alfanumericos": [
                    ""
                ],
                "valores_alfanumericos_acreditables": [
                    ""
                ],
                "descripcion": "Escala de 5 - 10, sin decimales",
                "created_at": "2020-09-22T18:50:02.000000Z",
                "updated_at": "2022-11-16T14:44:32.000000Z"
            }
        },
        {
            "materia": "Faltas",
            "clave": "",
            "promedia": "no",
            "periodos": [
                {
                    "detalle_componente_id": 952,
                    "periodo": "Periodo 1",
                    "calificacion": 1,
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 953,
                    "periodo": "Periodo 2",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 958,
                    "periodo": "Trimestre 1",
                    "calificacion": "NA",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 959,
                    "periodo": "Periodo 3",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 960,
                    "periodo": "Periodo 4",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 961,
                    "periodo": "Trimestre 2",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 962,
                    "periodo": "Periodo 5",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 963,
                    "periodo": "Periodo 6",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 964,
                    "periodo": "Trimestre 3",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 965,
                    "periodo": "Promedio Final",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                }
            ],
            "headers_codigo_sesion": {
                "header_faltas": "not_show",
                "header_retardos": "not_show",
                "header_conducta": "not_show",
                "header_tareas_no_hechas": "not_show",
                "header_observaciones": "not_show"
            }
        },
        {
            "materia": "Tareas no hechas",
            "clave": "",
            "promedia": "no",
            "periodos": [
                {
                    "detalle_componente_id": 952,
                    "periodo": "Periodo 1",
                    "calificacion": 2,
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 953,
                    "periodo": "Periodo 2",
                    "calificacion": 2,
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 958,
                    "periodo": "Trimestre 1",
                    "calificacion": "NA",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 959,
                    "periodo": "Periodo 3",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 960,
                    "periodo": "Periodo 4",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 961,
                    "periodo": "Trimestre 2",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 962,
                    "periodo": "Periodo 5",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 963,
                    "periodo": "Periodo 6",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 964,
                    "periodo": "Trimestre 3",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                },
                {
                    "detalle_componente_id": 965,
                    "periodo": "Promedio Final",
                    "calificacion": "-",
                    "status_captura_docente": true,
                    "faltas": "NA",
                    "retardos": "NA",
                    "conducta": "NA",
                    "tareas_no_hechas": "NA",
                    "observaciones": "NA"
                }
            ],
            "headers_codigo_sesion": {
                "header_faltas": "not_show",
                "header_retardos": "not_show",
                "header_conducta": "not_show",
                "header_tareas_no_hechas": "not_show",
                "header_observaciones": "not_show"
            }
        }
    ],
    "header_periodos": [
        {
            "detalle_componente_id": 952,
            "ponderacion": 1,
            "periodo": "Periodo 1",
            "status_show_alumno": true
        },
        {
            "detalle_componente_id": 953,
            "ponderacion": 2,
            "periodo": "Periodo 2",
            "status_show_alumno": true
        },
        {
            "detalle_componente_id": 958,
            "ponderacion": 3,
            "periodo": "Trimestre 1",
            "status_show_alumno": true
        },
        {
            "detalle_componente_id": 959,
            "ponderacion": 4,
            "periodo": "Periodo 3",
            "status_show_alumno": false
        },
        {
            "detalle_componente_id": 960,
            "ponderacion": 5,
            "periodo": "Periodo 4",
            "status_show_alumno": false
        },
        {
            "detalle_componente_id": 961,
            "ponderacion": 6,
            "periodo": "Trimestre 2",
            "status_show_alumno": false
        },
        {
            "detalle_componente_id": 962,
            "ponderacion": 7,
            "periodo": "Periodo 5",
            "status_show_alumno": false
        },
        {
            "detalle_componente_id": 963,
            "ponderacion": 8,
            "periodo": "Periodo 6",
            "status_show_alumno": false
        },
        {
            "detalle_componente_id": 964,
            "ponderacion": 9,
            "periodo": "Trimestre 3",
            "status_show_alumno": false
        },
        {
            "detalle_componente_id": 965,
            "ponderacion": 10,
            "periodo": "Promedio Final",
            "status_show_alumno": false
        }
    ],
    "params_configuracion": {
        "calificaciones": "show",
        "faltas": "show",
        "retardos": "not_show",
        "conducta": "not_show",
        "tareas_no_hechas": "show",
        "observaciones": "not_show"
    },
    "status_alumno_id": 8
}]
                this.getNumTotalCabecera()
                this.getPeriodosShow()
                setTimeout(()=>{
                    this.generarPDF()
                }, 500)
                    loading.close()
            } catch (error) {
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: 'Hubo un error, favor de contactar al administrador.'
                })
                    
            }
    },
        
  }
}
</script>

<style scoped>
.fontSix{
    font-size: 13px;
}
.fontEight{
    font-size: 15px;
}
.fontNine{
    font-size: 16px;
}

.cabeceraTable{
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
}

p{
    margin-bottom: 0;
}

.lineTogether {
    line-height: 1.5;
}

table tr th{
    font-size: 7px;
    margin: 0 2px;
}

.widthCabecera10{
    width: 10%;
}
.widthCabecera16{
    width: 6.25%;
}

.lineSeparadorCampoFormativo{
    width: 100%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0;
}
.lineSeparador{
    width: 99.5%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0 2px 0.5%;
}
.backgroundCampos:nth-last-child(even){
    background: rgba(217, 217, 217, 0.30);
}
.bottom-div {
    position: absolute;
    bottom: 0;
    width: 1240px;
    text-align: center;
}
</style>
